import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';
import { Account } from '../types/account';

export class ApiAccounts extends ApiBase {
  private static baseUrl: string = '/accounts';

  static async get(): Promise<any> {
    const url = this.baseUrl;

    const data = {};
    const config = { headers: { Authorization: this.token } };

    return await this.sendRequest(METHOD.GET, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }

  static async post(newAccount: Account): Promise<any> {
    const url = this.baseUrl;

    const data = {
      account: {
        firstName: newAccount.firstName,
        lastName: newAccount.lastName,
        mail: newAccount.email,
        company: newAccount.company,
        phone: newAccount.phone,
        country: newAccount.country,
        state: newAccount.state,
        address: newAccount.address,
        industry: newAccount.industry,
        language: newAccount.language,
      },
      password: newAccount.password,
    };

    const config = {};

    return await this.sendRequest(METHOD.POST, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }

  static async delete(): Promise<any> {
    const url = this.baseUrl;

    const data = {};
    const config = { headers: { Authorization: this.token } };

    return await this.sendRequest(METHOD.DELETE, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
